import React from 'react';
import { Box, Typography, Stack } from '@mui/material';

interface MessageProps {
  message: any;
}

const MessageNfmReply: React.FC<MessageProps> = ({ message }) => {
  // ✅ Extract data safely
  const nfmValues = message?.content?.values?.values || {};
  const plainText = message?.content?.text || '';
  const fallbackBody = message?.content?.body || '';

  // ✅ Utility to prettify field names
  const formatKey = (key: string) =>
    key.replace(/_/g, ' ').replace(/\b\w/g, (char) => char.toUpperCase());

  return (
    <Box>
      <Stack spacing={1}>
        {/* ✅ Show form values if present */}
        {Object.keys(nfmValues).length > 0 ? (
          Object.entries(nfmValues).map(([key, value]) => (
            <Typography key={key} variant="body2" sx={{ whiteSpace: 'pre-wrap' }}>
              <strong>{formatKey(key)}:</strong>{' '}
              {typeof value === 'object' ? JSON.stringify(value, null, 2) : value}
            </Typography>
          ))
        ) : (
          // ✅ Show fallback message if no values
          <Typography variant="body2" sx={{ whiteSpace: 'pre-wrap' }}>
            {plainText || fallbackBody || 'No content available'}
          </Typography>
        )}
      </Stack>
    </Box>
  );
};

export default MessageNfmReply;
